//////////////////////////////////////
import { axiosDefault } from '@/core/utils';
import {
	UpgradeActivityRequest,
	UpgradeActivityResponse,
} from '@/core/interfaces';
import { UserDailyComboMapper } from '@/core/mappers';

const upgrade = async ({
	id,
}: UpgradeActivityRequest): Promise<UpgradeActivityResponse> => {
	const url = `/tg/user/card/${id}/buy`;
	const response = await axiosDefault.put(url, null);
	return {
		currentCoins: response.data.currentCoins,
		currentDiamonds: response.data.currentDiamonds,
		isAwardWinning: response.data.isAwardWinning,
		totalCoinsEarned: response.data.totalCoinsEarned,
		data: response.data.data,
	};
};

const getDailyCombo = async () => {
	const url = `/tg/user/daily/combo`;
	const response = await axiosDefault.get(url);
	return UserDailyComboMapper(response.data);
};

const claimDailyCombo = async () => {
	const url = `/tg/user/daily/combo/claim`;
	const response = await axiosDefault.put(url);

	return {
		currentCoins: response.data.currentCoins,
		currentDiamonds: response.data.currentDiamonds,
		isAwardWinning: response.data.isAwardWinning,
		totalCoinsEarned: response.data.totalCoinsEarned,
		data: response.data.data,
	};
};

const revealDailyCombo = async () => {
	const url = `/tg/diamonds/daily/combo`;
	const response = await axiosDefault.put(url);

	return {
		currentCoins: response.data.currentCoins,
		currentDiamonds: response.data.currentDiamonds,
		isAwardWinning: response.data.isAwardWinning,
		totalCoinsEarned: response.data.totalCoinsEarned,
		data: response.data.data,
	};
};
export const ActivitiesService = {
	upgrade,
	getDailyCombo,
	claimDailyCombo,
	revealDailyCombo,
};
